import endpointUrls from 'global/Constants/endpointUrls';
import { IBackendSearchGeneric } from 'global/Models/globalModels';
import { customerCategory } from 'global/Models/userModel';
import { handleApiThenGeneric } from 'global/helperFunctions/handleApiThen';
import { localApiCatcher } from 'global/helperFunctions/localApiCatcher';
import ApiService, { errorResponse } from 'global/utils/ApiService';
import { setUserCustomerCategoryList } from 'redux/reducer/user/userReducer';
import { AppDispatch } from 'redux/store';

export const getAllCustomerCategory = () => async (dispatch: AppDispatch) => {
  await ApiService.post(endpointUrls.customerCategoryGetAll, { recordsPerPage: 50 })
    .then((res: IBackendSearchGeneric<customerCategory>) =>
      handleApiThenGeneric<IBackendSearchGeneric<customerCategory>, customerCategory[]>({
        res,
        onSuccessData: (data) => dispatch(setUserCustomerCategoryList(data)),
        notifFail: false,
        notifSuccess: false,
      })
    )
    .catch(() => localApiCatcher(errorResponse));
};
